export default __webpack_public_path__ + "static/media/netflixLogo.f73bccc4.png";